// token.interceptor.ts - Functional approach
import { HttpInterceptorFn, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { NgProgress } from '@ngx-progressbar/core';
import { environment } from 'environments/environment';
import * as fromCoreStore from '@app/core/store';
import { AuthService } from '@app/users/services/auth.service';
import { LoginRedirect, LogoutSuccess } from '../store/actions/auth.actions';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const store = inject(Store<fromCoreStore.State>);
  // const progress = inject(NgProgress);

  // Add authorization header if token exists
  let reqWithToken = req;
  const token = auth.getToken();

  if (token) {
    reqWithToken = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(reqWithToken).pipe(
    tap((event: HttpResponse<any>) => {
      if (event instanceof HttpResponse) {
        if (event?.body?.logout) {
          store.dispatch(new LogoutSuccess({ doNotRedirectToLogin: true }));
          store.dispatch(new LoginRedirect());
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      // A 401 from the lock server (GET /locks/all, PATCH /locks/batch, the SSE seed, etc.) must NOT
      // log the user out / bounce them to login — that connection lives independently of the main
      // session (it's just a best-effort lock sync) and its own client retries / backs off. Only a
      // 401 from the main API means the session is actually dead.
      const lockApiUrl = (environment as any).lockApiUrl;
      const isLockServerRequest = lockApiUrl && req.url?.startsWith(lockApiUrl);
      if (error.status === 401 && !isLockServerRequest) {
        const userIndex = String(parseInt(window.location.href.match(/\/(\d+)\//)?.[1] || '0', 10) || 0);
        auth.destroyToken(userIndex);
        auth.collectFailedRequest(req);
        store.dispatch(new LogoutSuccess({ doNotRedirectToLogin: true }));
        store.dispatch(new LoginRedirect());
      }
      return throwError(() => error);
    })
  );
};
